import {Injectable} from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from "@angular/router";
import {Observable} from "rxjs";
import { HttpResponse } from "@angular/common/http";
import {EstudioService} from "../estudio.service";


@Injectable({
  providedIn: 'root'
})
export class CategoriasUnidadResolver  {

    constructor(private router: Router, private estudioService: EstudioService) {
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<HttpResponse<any>> {
        return this.estudioService.getCategoriasByAgrupador('4,5,11,12')/*.map(categorias => {
            return categorias;
        })*/;
    }
}
